import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { getCardEmbedUrl } from "../../../services/api/banking/cards";

export const QUERY_CARD_EMBED_URL = "QUERY_CARD_EMBED_URL";

let EMBED_CSS = window.location.origin + "/embed-card.css";

export const useQueryCardEmbedUrl = (
  cardId: string,
  config?: WSQueryConfig<cardApiSpec.GetEmbedUrlResponse, WSServiceError>
) => {
  return useWSQuery<cardApiSpec.GetEmbedUrlResponse, WSServiceError>(
    [QUERY_CARD_EMBED_URL, cardId],
    () => getCardEmbedUrl(cardId, EMBED_CSS),
    {
      retry: false,
      ...config
    }
  );
};
